import { render, staticRenderFns } from "./invitedFriend.vue?vue&type=template&id=005c8175&scoped=true"
import script from "./invitedFriend.vue?vue&type=script&lang=js"
export * from "./invitedFriend.vue?vue&type=script&lang=js"
import style0 from "./invitedFriend.vue?vue&type=style&index=0&id=005c8175&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c8175",
  null
  
)

export default component.exports